import Q from 'q';

import cartsApi from 'bundles/payments-common/api/carts';

export default function (options: $TSFixMe) {
  return Q(cartsApi.post('', { data: options }));
}
